import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { WarehouseMaterialStockAdapter } from '../adapters/WarehouseMaterialStockAdapter';

export function useWarehouseMaterialAssignedLocations(productId: number | null, enabled: boolean) {
  return useQuery({
    queryKey: ['warehouse-material-assigned-locations', productId],
    enabled: enabled && productId != null,
    queryFn: async () => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new WarehouseMaterialStockAdapter(httpClient);
      return adapter.getLocationsByProduct(productId!);
    },
    staleTime: 60 * 1000,
  });
}
